import { useEffect, useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Context } from '../Context';

import styles from '../styles/bim.module.scss';

import { MOBILE_VIEW_TYPES } from '../constants/mobileViewTypes';
import { LAYER_TYPES } from '../constants/layerTypes';
const { TIERS_VIEW, APARTMENT_VIEW } = MOBILE_VIEW_TYPES;
const { APARTMENTS_LAYER } = LAYER_TYPES;

const Tooltip = ({ content, setTooltipVisible }) => {

  const [render, setRender] = useState(false);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const { 
    isMobile, 
    setActiveApartmentHandle, 
    setMobileActiveView, 
    activeApartment, 
    setActiveLayer, 
    setActiveTier, 
    activeLayer 
  } = useContext(Context);

  const { title, building, apartments, btntext, surface, rooms, tier, id, availability, floorId, comment, setScope } = content;

  const { t } = useTranslation();

  useEffect(() => {


    const handleMouseMove = (event) => {
      if (!isMobile) {
        setPosition({
          x: event.clientX + 10,
          y: event.clientY + 10,
        });
      } else {
        setPosition({
          x: 0,
          y: 0,
        });
      }
    };

    window.addEventListener('mousemove', handleMouseMove);
    const renderTimeout = setTimeout(() => {
        setRender(true);
    }, 100);

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      clearTimeout(renderTimeout);
    };



  }, [content, activeApartment]);

  useEffect(() => {
    setRender(false);
    // content = {};
  }, [activeLayer]);

  const isOnGroundFloor = false; //TODO !!important: remove this for projects other then ASNYKA
  const isOnFirstTwoFloors = false; //TODO !!important: remove this for projects other then ASNYKA
  // const isOnGroundFloor = title.toLowerCase().includes('0') || title.toLowerCase().includes('parter'); //TODO !!important: remove this for projects other then ASNYKA
  // const isOnFirstTwoFloors = title.includes('1') || title.includes('2'); //TODO !!important: remove this for projects other then ASNYKA

  return (<>
    {render && (
      <div
        key="tooltip" 
        className={styles.tooltip}
        style={{ 
          top: position.y, 
          left: position.x, 
          position: `${
            isMobile 
            ? 'absolute' 
            : 'fixed'
          }` 
        }}
        onClick={() => { setTooltipVisible(false) }}
      >

        {title && (
          <div className={styles.tooltip_title}>
            <span>
              {title}
            </span>
          </div>
        )}
        {availability && (
          <div className={styles.tooltip_apartments}>
            <span className={`state-${availability}`}>
              {t(availability)}
            </span>
          </div>
        )}
        {surface && (
          <div className={styles.tooltip_apartments}>
            <span>
              {surface} m<sup>2</sup>
            </span>
          </div>
        )}
        {rooms && (
          <div className={styles.tooltip_apartments}>
            <span>
              {rooms}
            </span>
            {
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
                <circle cx="9" cy="9" r="7" data-rooms={rooms.split(":")[1].trim()} className='rooms-color'/>
              </svg>
            }
          </div>
        )}
        {tier && (
          <div className={styles.tooltip_apartments}>
            <span>
              {tier}
            </span>
          </div>
        )}
        {building !== undefined && (
          <div className={styles.tooltip_apartments}>
            <span>
              {t('building')} -
            </span>
            <span>{building}</span>
          </div>
        )}
        {apartments !== undefined && (
          <div className={styles.tooltip_apartments}>
            <span>
              {isOnGroundFloor ? t('apartments') : isOnFirstTwoFloors ? t('premisses_plural') : t('apartment_plural')} -
            </span>
            <span>{apartments || 0}</span>
          </div>
        )}
        {comment && (
          <div className={styles.tooltip_apartments}>
            <span>
              {comment}
            </span>
          </div>
        )}
        {btntext && (
          <div className={styles.tooltip_btntext} onClick={() => {
            if (isMobile) {
              if (id) {
                setActiveApartmentHandle(id);
                setActiveLayer(APARTMENTS_LAYER);
                setMobileActiveView(APARTMENT_VIEW);
              } else if (floorId) {
                setActiveTier(floorId);
                setMobileActiveView(TIERS_VIEW);
              } else {
                setScope && setScope(2);
                setActiveLayer(APARTMENTS_LAYER);
              }
            } else if (id) {
              setActiveApartmentHandle(id);
            }
          }}>
            <span>
              {btntext}
            </span>
          </div>
        )}
      </div>
    )}
  </>
  );
};

export default Tooltip;
